import React from "react";
import styles from "./Reports.module.css";

// Horizontal bars, one per row: a label, a bar filled to value/max in the row's colour, and the figure on the right.
// `target` (0–1) draws a thin marker line across every bar.
export default function BarList({ rows, max, target = null, ariaLabel }) {
  const top = max ?? Math.max(...rows.map((r) => r.value), 1);
  return (
    <ul className={styles.barList} aria-label={ariaLabel}>
      {rows.map((r) => (
        <li key={r.label}>
          <span className={styles.barLabel} title={r.label}>{r.label}</span>
          <span className={styles.barTrack}>
            <span className={styles.barFill} style={{ width: `${Math.min(100, (Math.max(r.value, 0) / top) * 100)}%`, background: r.color }} />
            {target != null && <span className={styles.barTarget} style={{ left: `${target * 100}%` }} />}
          </span>
          <span className={styles.barValue}>{r.display}</span>
        </li>
      ))}
    </ul>
  );
}
